export default {"src":"/_next/static/media/baksta.ccf05afe.svg","height":68,"width":216,"blurWidth":0,"blurHeight":0};